import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { Modal, ModalBody} from 'reactstrap';
import UploadFile from '../includes/UploadFile';
import AutoComplete from '../includes/AutoComplete';
import * as vignetsActions from "../../actions/vignets";
import {withRouter} from 'react-router';
import * as uploadActions from "../../actions/upload";
import * as playlistActions from "../../actions/playlist";
import AuthService from '../../lib/AuthService';

class VignetNewItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: '',
            vname_class : '',
            vtags_class : '',
            vignet_name: '',
            vignet_tags: '',
            vignet_desc :'',
            titleError  : '',
            modal: false,
            redirect: false,
            builderState : false,
            builderUrl : '',
            image_path: null,
            selectedProjects: []

        };
        this.Auth = new AuthService();
        this.toggle = this.toggle.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.showBuilder = this.showBuilder.bind(this);
        this.hideBuilder = this.hideBuilder.bind(this);

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.vignetsData.modalOpen !== prevProps.vignetsData.modalOpen) {
            this.setState({modal : this.props.vignetsData.modalOpen});
        }
    }

    toggle() {
        this.setState({
            modal: !this.state.modal,
            image_path: null,
            vignet_name : '',
            vignet_desc : '',
            vignet_tag : '',
            titleError : ''
        });
        this.props.uploadErrors({'error' : '', fileType : ''});
        this.props.modalToggle({modalOpen : !this.state.modal, modalTitle : "", "modalType" : ""});
    }

    getUploadedFile(fileName) {
        console.log(fileName);
        this.setState({
            image_path: fileName
        });
        //Request to purging
        this.props.getImagepurged({image_name : 'cf'+this.state.vignet_id, image_path : fileName});

    }

    showBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : true
        });
        this.handleSubmit(e, this.state.builderState);
    }

    hideBuilder(e) {
        e.preventDefault();
        this.setState({
            builderState : false
        });
        this.handleSubmit(e, this.state.builderState);
    }

    handleInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        });

        if(event.target.value !== '') {
            event.target.classList.remove('is-invalid');
        }
        if(this.state.vignet_name !== ''){
            this.setState({
                titleError: ''
            });
        }
    }

    handleSubmit(e) {
        console.log(this.state);
        //e.preventDefault();
        let formInvalid = 0;

        if( this.state.vignet_name === '') {
            formInvalid++;
            document.getElementsByName('vignet_name')[0].classList.add('is-invalid');
            this.setState({
                titleError: 'Title is required'
            });
        }

        if( formInvalid === 0) {

            if( this.props.vignetsData.modalType === 'new-vig') {
                var vigData = { userid : this.Auth.getProfile().user_id ,title :this.state.vignet_name, vig_image : this.state.image_path, description: this.state.vignet_desc ,tags: this.state.vignet_tags, projects : this.state.selectedProjects};
                this.props.createVignet(vigData);
            }
            else {
                var vigData = { user_id : this.Auth.getProfile().user_id ,title :this.state.vignet_name, vig_image : this.state.image_path, description: this.state.vignet_desc ,tags: this.state.vignet_tags, vigids : this.props.vignetsData.selected_ids, projects : this.state.selectedProjects};

                this.props.joinVignets(vigData);
            }

            this.toggle();
        }
    }

    resultDataList( result, reference, valueField) {
        this.setState({ [reference] : result });
        let uniqueIds = result.map(item => item[valueField]);
        //console.log(uniqueIds);
        this.props.setSelectedItems(reference, uniqueIds);

    }

    render() {

        return (

                <Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} className="vig-mod modal-lg vig-modal user-md create-new-pop" id="vignetModal-user" tabindex="-1" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <ModalBody>
                        <div className="modal-content-wrapper">
                            <div className="modal-header">
                                <form id="company">
                                    <button type="button" className="modal-btn-close" data-dismiss="modal" aria-label="Close" onClick={this.toggle} >✕</button>
                                    <h4 className="modal-title">{this.props.vignetsData.modalTitle}</h4>
                                </form>
                            </div>
                            <div className="modal-adduser-content">
                                <div className="modal-adduser-content-left">
                                    <div className="modal-adduser-detail">
                                        <p>TITLE</p>
                                        <div className="input-select">
                                            <input type="text" name="vignet_name" id="vignet_name" placeholder="Title" onChange={this.handleInputChange} valid={false} />
                                            <p className="error-message">{this.state.titleError}</p>

                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>DESCRIPTION</p>
                                        <div className="input-select medium-desc-area">
                                            <textarea type="textarea"  className="form-text" name="vignet_desc" id="vignet_desc"   placeholder="Description" onChange={this.handleInputChange} valid={false}/>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>TAGS</p>
                                        <div className="input-select medium-desc-area">
                                            <textarea type="textarea" name="vignet_tags" className="form-text" id="vignet_tags"  placeholder="Tags" onChange={this.handleInputChange} valid={false}/>
                                        </div>
                                    </div>
                                    <div className="modal-adduser-detail">
                                        <p>Project</p>
                                        <div className="input-select medium-desc-area">
                                            {<AutoComplete
                                                fieldTitle = 'Project'
                                                sourceDataList = {this.props.vignetsData.projectList}
                                                searchField = 'project_name'
                                                showIcon={true}
                                                showSubLabel = {true}
                                                labelFields = 'project_name'
                                                valueField ='project_id'
                                                subLabelField = 'project_id'
                                                showProfile = {true}
                                                reference='selectedProjects'
                                                selectedItems = {this.state.selectedProjects}
                                                resultDataList = {this.resultDataList.bind(this)}
                                                id="to_users"
                                                instantSearch = {true}
                                                actionMethod = {this.props.getProjects}
                                            />}
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-adduser-content-right">
                                    <div className="modal-adduser-detail">
                                        <div className="modal-adduser-img">
                                            <div className="image-up">

                                                {this.state.image_path &&
                                                <img src={this.state.image_path} crossOrigin="anonymous" className="text-center" alt="vignet"/>
                                                }
                                                {this.state.image_path ===null &&
                                                <img src="assets/images/placeholder.png" alt="default" />
                                                }

                                                <UploadFile getUploadedFile={ this.getUploadedFile.bind(this)} type="add" item_type="VIGNETS" fileType="image" unique_id = ""/>
                                                {(this.state.image_path ===null || this.props.uploadData.loader === true) &&
                                                <div id="progress-bar-wrapper"></div>
                                                }
                                            </div>
                                        </div>
                                        {this.props.uploadData.errors === true &&
                                        <p className="error-message">{this.props.uploadData.errorMessage}</p>
                                        }
                                    </div>
                                </div>
                                <div className="modal-adduser-content-btn">
                                    <div className="modal-btn btn-cancel">
                                        <a href="javascript:void(0);" className="" onClick={this.toggle}>CANCEL</a>
                                    </div>
                                    <div  className="modal-btn btn-create">
                                        <a href="javascript:void(0);" className="" onClick = {(e) => this.handleSubmit(e)}>SAVE</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
        );
    }
}

VignetNewItem.propTypes = {
    completed: PropTypes.number,
    title : PropTypes.string
}

function mapStateToProps(state) {
    return {
        uploadData : state.upload.uploadData,
        vignetsData : state.vignets.vignetsData,
        selectedItems : state.vignets.getSelectedItems
    };
}

export default  withRouter(connect(mapStateToProps, {
    createVignet : vignetsActions.createVignet,
    uploadErrors: uploadActions.uploadErrors,
    getImagepurged : playlistActions.purgeImage,
    modalToggle : vignetsActions.toggleModal,
    joinVignets : vignetsActions.joinVignets,
    setSelectedItems : vignetsActions.setSelectedItems
})(VignetNewItem));



// WEBPACK FOOTER //
// ./src/components/vignets/VignetNewItem.js